module.exports = __webpack_public_path__ + "assets/img/logo.5e31468b.png";